import { createEntityAdapter } from "@reduxjs/toolkit";

import type { NetworkResponse } from "./types";

export const networkResponseAdapter = createEntityAdapter({
  selectId: ({ requestId }: NetworkResponse) => requestId,
});
